import { usePostMutation } from "@/api/swr/useMutation";
import { assessorCreateSchema } from "@/schema/console/assessors/AssessorCreate";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof assessorCreateSchema, z.ZodNull>
>[3];

export const useCreateAssessor = (config?: Config) => {
  return usePostMutation(
    assessorCreateSchema,
    z.null(),
    "/console/admin_users",
    config,
  );
};
